import { render, staticRenderFns } from "./EmptyBlock.vue?vue&type=template&id=0fbf1ae4&"
import script from "./EmptyBlock.vue?vue&type=script&lang=js&"
export * from "./EmptyBlock.vue?vue&type=script&lang=js&"
import style0 from "./EmptyBlock.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports